import axios from "axios";
axios.defaults.httpsAgent = new (require("https").Agent)({
	rejectUnauthorized: false,
});
export default axios.create({
	// baseURL: "https://cloudbackend.auscomp.au/",
	baseURL: process.env.REACT_APP_API_URL,
	// baseURL: process.env.NEXT_PUBLIC_API_URL,
	headers: {
		"X-Requested-With": "XMLHttpRequest",
		rejectUnauthorized: false,
	},
	withCredentials: true,
});
